module.exports = __webpack_public_path__ + "img/image-default-full.1b931593.svg";